export class CreateCredentialsProfileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateCredentialsProfileInputAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "UpdateCredentialsProfileInputGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateCredentialsProfileInput.attributeTypeMap;
    }
    constructor() {
    }
}
